// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0b28ec28","470":"bf651ab3"}[chunkId] + ".chunk.js";
};